import { handleActions } from 'redux-actions';

import reducersUtils from 'state/utils';

import actions from 'state/direct-order-recurring/range/actionCreators';

import initialState from 'state/direct-order-recurring/range/initial.state';

const range = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setRange]: (state, { payload: { type, value } }) => ({
      ...state,
      [type]: value,
    }),
  },
  initialState
);

export default range;
